<template>
  <div class="bg-gradient-to-r from-[#1E1E1E] to-black text-white md:py-24 py-12">
    <Container>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 lg:gap-24">
        <!-- First Column - Company Info -->
        <div class="space-y-5 md:col-span-2 justify-between">
          <h3 class="body-1 font-medium uppercase">
            SURYA BINTANG ADVENTURES
          </h3>
          <p class="body-2 leading-loose">
            Surya Bintang Adventures brings you the best of Bali's activities with safe, exciting rafting and ATV rides. Our commitment to safety, fun, and unforgettable service has earned appreciation and received the Bali Leading Tourism Activity Operator Award 2025-2026.
          </p>
          <NuxtImg
            src="/surya-bintang-logo-dark.png"
            alt="logo surya bintang adventure"
            format="webp"
            class="w-24 md:w-auto"
          />
        </div>

        <!-- Mobile: Stack all columns vertically, Desktop: Use flex layout -->
        <div class="grid grid-cols-1 md:flex md:justify-between md:col-span-2 space-y-8 md:space-y-0">
          <!-- Quick Links Column -->
          <div class="space-y-4">
            <h3 class="text-sm uppercase tracking-wide">
              QUICK LINKS
            </h3>
            <div class="grid grid-cols-2 md:grid-cols-1 gap-2">
              <NuxtLink to="/" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Home</NuxtLink>
              <NuxtLink to="/about" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">About Us</NuxtLink>
              <NuxtLink to="/kayaking" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Kayaking</NuxtLink>
              <NuxtLink to="/activities" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Activities</NuxtLink>
              <NuxtLink to="/our-history" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Our History</NuxtLink>
              <NuxtLink to="/restaurant" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Restaurant</NuxtLink>
              <NuxtLink to="/blog" class="block text-sm text-gray-300 hover:text-white transition-colors py-1">Blog</NuxtLink>
              <NuxtLink to="/contact-us" class="block text-sm text-gray-300 hover:text-white transition-colors py-1 md:col-span-1 col-span-2">Contact</NuxtLink>
            </div>
          </div>

          <!-- Services Column -->
          <div class="space-y-4">
            <h3 class="text-sm uppercase tracking-wide">
              OUR SERVICES
            </h3>
            <div class="grid grid-cols-2 md:grid-cols-1 gap-2">
              <p class="text-sm text-gray-300 py-1">Rafting Adventures</p>
              <p class="text-sm text-gray-300 py-1">ATV Rides</p>
              <p class="text-sm text-gray-300 py-1">Cycling Tours</p>
              <p class="text-sm text-gray-300 py-1">Trekking</p>
              <p class="text-sm text-gray-300 py-1">Combo Packages</p>
              <p class="text-sm text-gray-300 py-1">Transportation</p>
            </div>
          </div>

          <!-- Contact Information Column -->
          <div class="space-y-4">
            <h3 class="text-sm uppercase tracking-wide">
              CONTACT INFO
            </h3>
            <div class="space-y-2">
              <p class="text-sm text-gray-300 leading-relaxed">Jl. Raya Payangan, Melinggih Kelod</p>
              <p class="text-sm text-gray-300 leading-relaxed">Kec. Payangan, Kabupaten Gianyar</p>
              <p class="text-sm text-gray-300 leading-relaxed">Bali 80572, Indonesia</p>
              <p class="text-sm text-gray-300 py-2">
                <a href="tel:+62818881388" class="hover:text-white transition-colors">+62 818 881 388</a>
              </p>
              <p class="text-sm text-gray-300 py-2">
                <a href="mailto:info@suryabintangadventures.com" class="hover:text-white transition-colors break-all">info@suryabintangadventures.com</a>
              </p>
            </div>
            <!-- Social Media Icons -->
            <div class="flex space-x-4 pt-2">
              <a href="https://www.instagram.com/suryabintang_adventures/" target="_blank" class="hover:opacity-80 transition-opacity p-1">
                <Icon name="mdi:instagram" class="text-2xl" />
              </a>
              <a href="https://www.facebook.com/suryabintangadventurebali" target="_blank" class="hover:opacity-80 transition-opacity p-1">
                <Icon name="mdi:facebook" class="text-2xl" />
              </a>
              <a href="https://www.youtube.com/@suryabintangadventures" target="_blank" class="hover:opacity-80 transition-opacity p-1">
                <Icon name="mdi:youtube" class="text-2xl" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const currentYear = computed(() => {
  return new Date().getFullYear()
})
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
